import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useQuery } from "react-query";
import { useAppSelector } from "redux/hooks";
import {
  CardData,
  CategoryDef,
  LegendType,
} from "api/interfaces/dashboardInterface.interface";
import ChartWrapper from "../graph/ChartWrapper";
import { useMemo } from "react";
import { getWidgetEuLicense } from "api/widgetAPI";
import { getLegendForKey } from "utils/StatsUtil";
import { formatNumber } from "utils/functions";

export default function EuLicense(props: CardData) {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const euLicense = useQuery(
    ["euLicense", selectedAccount.accountId],
    () => {
      return getWidgetEuLicense(selectedAccount.accountId);
    },
    {
      retry: 0,
      refetchOnWindowFocus: false,
    }
  );
  const { data, legend } = useMemo(() => {
    if (euLicense.data) {
      const convertData = getLegendForKey(
        euLicense.data.result,
        props.items ?? []
      );
      return {
        data: convertData,
        legend: convertData.map((item) => ({
          ...item,
          value: formatNumber(item.value),
        })),
      };
    }
    return {
      data: [],
      legend: [],
    };
  }, [props.items, euLicense.data]);
  return (
    <ChartWrapper
      rows={data}
      items={props.items as CategoryDef[]}
      legend={legend}
      isLoading={euLicense.isLoading}
    />
  );
}
